import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithTokenHandling } from '../baseQuery';
import { REGION_TAG_TYPE } from './constants';

export const regionsApi = createApi({
  reducerPath: 'regionsApi',
  baseQuery: baseQueryWithTokenHandling,
  tagTypes: [REGION_TAG_TYPE],
  endpoints: (builder) => ({
    /**
     * Get a single region with full geometry
     * Returns polygons in same format as territories (boundary + holes)
     */
    getRegion: builder.query<MedScout.Region, { regionId: string }>({
      query: ({ regionId }) => `v1/accounts/regions/${regionId}/`,
      providesTags: [REGION_TAG_TYPE],
    }),
  }),
});

export const { useGetRegionQuery, useLazyGetRegionQuery } = regionsApi;
